<script>
    import RoleObject from '@/components/page-user-edit/RoleObject.vue';

    export default {
        computed: {
            roles() { return this.$store.getters.ROLES },
        },
        components: {
            RoleObject: RoleObject
        }
    }
</script>


<template>
    <div class="right_header">
        <label>Role [{{ roles.length }}]</label>
    </div>
    <ul class="clear_ul">
        <RoleObject
            v-for="(roleValue, roleIndex) in roles" :key="roleIndex"
            :role = "roleValue"
        />
    </ul>
</template>